import type { HumanName, PatientBanner } from '@ampshift/shared';

export function fullName(name: HumanName, preferArabic = false): string {
  if (preferArabic && name.alternate) return name.alternate;
  return [name.given, name.middle, name.family].filter(Boolean).join(' ');
}

export function ageFromBirthDate(birthDate: string, now: Date = new Date()): number | undefined {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthDate);
  if (!m) return undefined;
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);
  let age = now.getFullYear() - y;
  if (now.getMonth() < mo || (now.getMonth() === mo && now.getDate() < d)) age -= 1;
  return age >= 0 && age < 150 ? age : undefined;
}

export function sexLabel(sex: PatientBanner['sex']): string {
  return { male: 'M', female: 'F', other: 'O', unknown: '?' }[sex];
}

export function formatTime(iso: string, timeZone?: string, locale = 'en-GB'): string {
  try {
    return new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', ...(timeZone ? { timeZone } : {}) }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatDate(iso: string, locale = 'en-GB', timeZone?: string): string {
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) return iso;
  try {
    return new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', ...(timeZone ? { timeZone } : {}) }).format(new Date(iso));
  } catch {
    return iso;
  }
}

/** Lab flag classes: H/HH/high → red, L/LL/low → blue, anything else → neutral marker. */
export function flagClass(flag: string | undefined | null): string {
  if (!flag) return '';
  const f = flag.toUpperCase();
  if (f === 'H' || f === 'HH' || f === 'HIGH' || f === 'CRITICAL_HIGH' || f === 'CH') return 'flag flag-high';
  if (f === 'L' || f === 'LL' || f === 'LOW' || f === 'CRITICAL_LOW' || f === 'CL') return 'flag flag-low';
  if (f === 'A' || f === 'ABNORMAL') return 'flag flag-abnormal';
  return 'flag';
}
